import { render, staticRenderFns } from "./DocumentPreviewCard.vue?vue&type=template&id=7f3c733b&scoped=true&"
import script from "./DocumentPreviewCard.vue?vue&type=script&lang=js&"
export * from "./DocumentPreviewCard.vue?vue&type=script&lang=js&"
import style0 from "./DocumentPreviewCard.vue?vue&type=style&index=0&id=7f3c733b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3c733b",
  null
  
)

export default component.exports